import { FC, type ReactElement } from 'react';
import toastLoadingIcon from '@assets/images/parrot/toast-loading.svg';
import styles from './index.module.scss';

interface OwnProps {
  description: string | ReactElement;
}

const ToastLoading: FC<OwnProps> = ({ description }) => {
  return (
    <div className={styles.wrapper}>
      <img src={toastLoadingIcon} />
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default ToastLoading;
